import { HTTP } from './http-common';
import { UTILS } from './http-common';
import {
  privateAPI,
  privateServiceURL,
  setPrivateServiceURL,
} from '@Base/plugins/axios.js';

export default {
  fixServiceBaseUrl(response) {
    // console.log(
    //   `**** before - fixServiceBaseUrl() called! -> ${privateServiceURL}`
    // );
    if (response.request.responseURL) {
      setPrivateServiceURL(response.request.responseURL.split('solicitud/')[0]);
    } else {
      setPrivateServiceURL(window.location.href.split('#/')[0]);
    }
    // console.log(
    //   `**** after - fixServiceBaseUrl() called! -> ${privateServiceURL}`
    // );
  },

  // internal redirect
  getInternalRedirect(token, cbok, cberr) {
    const me = this;

    return privateAPI({
      url: `solicitud/internal-redirect/${token}`,
      method: 'GET',
    })
      .then(function (response) {
        cbok(response.data);
        me.fixServiceBaseUrl(response);
      })
      .catch(function (error) {
        cberr(error);
      });
  },

  getSolicitanteInterno(token, cbok, cberr) {
    const me = this;

    return privateAPI({
      url: 'solicitud/getSolicitante',
      method: 'GET',
    })
      .then(function (response) {
        cbok(response.data);
        me.fixServiceBaseUrl(response);
      })
      .catch(function (error) {
        cberr(error);
      });
  },

  // obtener solicitante
  getSolicitante(token, cbok, cberr) {
    const me = this;

    return privateAPI({
      url: `solicitud/getSolicitante/${token}`,
      method: 'GET',
    })
      .then(function (response) {
        cbok(response.data);
        me.fixServiceBaseUrl(response);
      })
      .catch(function (error) {
        cberr(error);
      });
  },

  // obtener expedientes
  getExpedientes(token, cbok, cberr) {
    return privateAPI({
      url: 'solicitud/expedientes',
      method: 'GET',
      config: {
        headers: {
          'content-type': 'application/json',
          'X-SOLICITUD': token,
        },
      },
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },

  // obtener notificacion pendiente
  getNotificacionPendiente(idNotificacion = null, cbok, cberr) {
    const idNotificacionActual = idNotificacion || '';
    const url = `notificacion/pendiente?idNotificacion=${idNotificacionActual}`;
    return privateAPI({
      url: url,
      method: 'GET',
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },

  // obtener confirmacion
  getIdConfirmacion(idSolicitud, tipo, token, cbok, cberr) {
    return privateAPI({
      url: `confirmacion/${idSolicitud}/${tipo}/get_ultima`,
      method: 'GET',
      config: {
        headers: {
          'content-type': 'application/json',
          'X-SOLICITUD': token,
        },
      },
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },

  // validar usuario
  validateUser(usuario, cbok, cberr) {
    return privateAPI({
      url: 'solicitud/validateUser',
      method: 'POST',
      data: usuario,
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },

  // comprobar solicitud
  comprobarSolicitud(usuario, cbok, cberr) {
    const me = this;

    return privateAPI({
      url: 'solicitud/comprobarSolicitud',
      method: 'POST',
      data: usuario,
    })
      .then(function (response) {
        cbok(response.data);
        me.fixServiceBaseUrl(response);
      })
      .catch(function (error) {
        cberr(error);
      });
  },

  // comprueba si está bloqueado un expediente
  verificarExpedienteBloqueado(idSolicitud = null, cbok, cberr) {
    const url = `notificacion/bloqueado/${idSolicitud}`;
    return privateAPI({
      url: url,
      method: 'GET',
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },

  // comprueba si la solicitud es de tipo CATA DANA
  comprobarCataDana(usuario, cbok, cberr) {
    return privateAPI({
      url: 'solicitud/esCataDana',
      method: 'POST',
      data: usuario,
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },

  // enviar enlace
  enviarEnlace(id, canal, cbok, cberr) {
    return privateAPI({
      url: `solicitud/${id}/enviarEnlace`,
      method: 'POST',
      data: canal,
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },

  getDocumentoNotificacion(id, cbok, cberr) {
    return privateAPI({
      url: `notificacion/getDocumento/${id}`,
      method: 'GET',
      options: {
        responseType: 'blob',
      },
    })
      .then(function (response) {
        cbok(response.data);
        UTILS.downloadDocument(response);
      })
      .catch(function (error) {
        cberr(error);
      });
  },

  getDocumentosNotificacion(id, cbok, cberr) {
    return privateAPI({
      url: `solicitud/getDocumentosNotificacion/${id}`,
      method: 'GET',
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },

  getListCertificados(id, cbok, cberr) {
    return privateAPI({
      url: `certificados/list/${id}`,
      method: 'GET',
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },

  getResoluciones(id, cbok, cberr) {
    return privateAPI({
      url: `notificacion/resoluciones/${id}`,
      method: 'GET',
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },

  getDocumentos(idNotificacionFavorableAbono, cbok, cberr) {
    const idNotificacion = idNotificacionFavorableAbono || '';
    return privateAPI({
      url: `solicitud/getDocumentos?idNotificacion=${idNotificacion}`,
      method: 'GET',
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },

  getDocumentoJustificante(cbok, cberr) {
    HTTP.get(
      privateServiceURL +
        'tramite/' +
        window.$store.state.solicitud.solicitante.idSolicitante +
        '/justificante',
      {
        responseType: 'blob',
        headers: {
          'X-SOLICITUD': window.$store.state.solicitud.tokenGestion,
        },
      }
    )
      .then((response) => {
        cbok(response.data);
        UTILS.downloadDocument(response);
      })
      .catch(function (error) {
        cberr(error);
      });
  },

  getDocumento(id, cbok, cberr) {
    HTTP.get(privateServiceURL + 'solicitud/getDocumento/' + id, {
      responseType: 'blob',
      headers: {
        'X-SOLICITUD': window.$store.state.solicitud.tokenGestion,
      },
    })
      .then((response) => {
        cbok(response.data);
        UTILS.downloadDocument(response);
      })
      .catch(function (error) {
        cberr(error);
      });
  },

  getEstadoActualizado(idSolicitud, cbok, cberr) {
    return privateAPI({
      url: `service/getEstadoSolicitudActualizado/${idSolicitud}`,
      method: 'GET',
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },
  compruebaNotificacionCaducada(idNotificacion, cbok, cberr) {
    return privateAPI({
      url: `notificacion/notificacion-caducada/${idNotificacion}`,
      method: 'GET',
    })
      .then(function (response) {
        cbok(response.data);
      })
      .catch(function (error) {
        cberr(error);
      });
  },
};
